{
  "version": 1,
  "asset_id": "dbf2eb48-29c7-458e-bcc0-0984f17f3cf5",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/dbf2eb48-29c7-458e-bcc0-0984f17f3cf5/lynx-gsc-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/dbf2eb48-29c7-458e-bcc0-0984f17f3cf5/lynx-gsc-640.avif",
  "original_filename": "lynx-gsc-640.avif",
  "size": 12425,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:37Z"
}
